export const GlobalEndpointConstants = {
  CUM: 'arkik-customermanagement/',
  CUM2: 'arkik-planning/',
  CUM3: 'arkik-record/',
  CertifyProducts: 'cprod/',
  Order: 'comorder',
  ComPartner: 'compartner',
  CustomerManagement: 'arkik-customermanagement/',
  Make: 'make/',
  Repm: 'repm/',
  StockMovement: 'stkm/',
  Version1: 'v1/',
  Version2: 'v2/',
  Version5: 'v5/',
  Version6: 'v6/',
  Version8: 'v8/',
  dm: 'dm/',
  DTM: 'dtm/',
  NTF: 'ntf/',
  SM: 'sm/',
  Link: 'arkik-link/',
  ext: 'eordr/',
  pumpsheet: 'pumpsheet/',
};
